import { Link } from '@inertiajs/react'
import type { TeamMember } from '../../types'
import { sortPeople } from '../../utils/peopleSort'

export default function TeamMembersCard({ members, teamId }: { members: TeamMember[]; teamId: number }) {
  return (
    <div className="bg-white rounded-lg border border-stone">
      <div className="flex items-center justify-between px-5 py-4 border-b border-stone">
        <h3 className="text-base font-bold uppercase tracking-widest text-text-secondary">
          Team Members ({members.length})
        </h3>
        <Link href={`/teams/${teamId}/settings`} className="text-sm font-semibold text-text-primary hover:underline">
          Manage Team →
        </Link>
      </div>

      <div className="p-5">
        {members.length > 0 ? (
          <div className="flex flex-wrap gap-3">
            {sortPeople(members).map((m: TeamMember) => (
              <div key={m.id} className="flex flex-col items-center gap-1">
                <div
                  className="w-12 h-12 rounded-full bg-charcoal/10 text-text-primary text-base font-bold flex items-center justify-center"
                  title={`${m.first_name} ${m.last_name}`}
                >
                  {m.initials}
                </div>
                <span className="text-[13px] text-text-secondary max-w-[64px] truncate text-center">
                  {m.first_name}
                </span>
                {m.role !== 'member' && (
                  <span className="text-[10px] font-semibold uppercase tracking-wide text-text-primary">
                    {m.role}
                  </span>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="text-base text-text-secondary text-center py-4">
            No team members yet.{' '}
            <Link href={`/teams/${teamId}/settings`} className="text-text-primary hover:underline">
              Add members
            </Link>
          </p>
        )}
      </div>
    </div>
  )
}
